import { Get, Post, getAPIUrl } from "../../ApiServices/apiMethod";
import { AuthService, HomePageService } from "../../ApiServices/Axios/Index";
import { Authendpoint } from "./AuthEndpoint";

export const userLogin = (data, param = "") => {
  const url = getAPIUrl(Authendpoint.Login, param);
  return Post(AuthService, url, data, false);
};
export const userRegister = (data, param = "") => {
  const url = getAPIUrl(Authendpoint.SignUp, param);
  return Post(AuthService, url, data, false);
};

